import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import cookiesHelper from '../services/cookies/cookiesHelper';

export interface CookiesState {
  statisticsCookieAccepted: boolean;
  marketingCookiesAccepted: boolean;
  aiSessionId(): string | null | undefined;
  aiUserId(): string | null | undefined;
  updateCookieState: () => void;
  renewCookieSettings: () => void;
}

export const useCookiesStore = create<CookiesState>()(
  devtools((set) => ({
    statisticsCookieAccepted: cookiesHelper.getStatisticsCookiesAllowed(),
    marketingCookiesAccepted: cookiesHelper.getMarketingCookiesAllowed(),
    aiSessionId: () => cookiesHelper.getAppInsightsSessionCookieValue(),
    aiUserId: () => cookiesHelper.getAppInsightsUserCookieValue(),
    updateCookieState: () => {
      set({
        statisticsCookieAccepted: cookiesHelper.getStatisticsCookiesAllowed(),
        marketingCookiesAccepted: cookiesHelper.getMarketingCookiesAllowed(),
      });
    },
    renewCookieSettings: () => {
      cookiesHelper.renewSettings();
    },
  }))
);
